var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      attrs: {
        to: {
          name: "watchlistDetail",
          params: { id: _vm.watchlist.uid, watchlist: _vm.watchlist }
        }
      }
    },
    [_c("watchlist-teaser", { attrs: { watchlist: _vm.watchlist } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }